export default "__VITE_ASSET__838dacd2__"